import React, { Component } from "react";
import Login from "./Login";
import firebase from "firebase";
import { Redirect } from "react-router-dom";
class Admin extends Component {
  state = {
    email: "",
    psw: "",
    admin: "",
    erro: "",
    checked: false,
    authStatus: false,
    redirect: false,
  };

  componentDidMount() {
    var db = firebase.firestore();
    db.collection("admin")
      .doc("admin")
      .get()
      .then((doc) => {
        this.setState({ admin: doc.data() });
      });
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };
  handlePswChange = (e) => {
    this.setState({ psw: e.target.value });
  };
  handleClickSubmit = () => {
    if (
      this.state.admin.email === this.state.email &&
      this.state.admin.password === this.state.psw
    ) {
      this.setState({ error: "", authStatus: true, redirect: true });
      localStorage.setItem("authStatus", true);
    } else {
      this.setState({ error: "Something Went Wrong!" });
    }
  };
  handleCheckChange = () => {
    this.setState({ checked: !this.state.checked });
  };

  renderRedierct = () => {
    if (this.state.redirect && localStorage.getItem("authStatus") === "true")
      return <Redirect to="/admin_l7/home" />;
  };

  render() {
    return (
      <div>
        {this.renderRedierct()}
        <Login
          handleClickSubmit={this.handleClickSubmit}
          handleEmailChange={this.handleEmailChange}
          handlePswChange={this.handlePswChange}
          handleCheckChange={this.handleCheckChange}
          error={this.state.error}
          checked={this.state.checked}
        />
      </div>
    );
  }
}

export default Admin;
